import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';
import {
	IWidgetState,
	WidgetState,
	WidgetStateFactory,
	WidgetStateFactoryFromJS
} from './widgets/model';
import {
	DashboardFormData,
	DashboardFormDataFactory,
	DashboardFormDataFactoryFromJS,
	IDashboardFormData
} from './IDashboardFormData';

export interface IDashboardState {
	panelId: string;
	widgets: IWidgetState;
	dashboardType: 'user' | 'admin';
	dashboardFormData: IDashboardFormData;
}

export interface IReadonlyDashboardState {
	panelId: string;
	widgets: WidgetState;
	dashboardType: 'user' | 'admin';
	dashboardFormData: DashboardFormData;
}

export type DashboardState = ReadonlyRecord<IReadonlyDashboardState>;

export const DashboardStateFactory = Record<IReadonlyDashboardState>({
	panelId: null,
	widgets: WidgetStateFactory(),
	dashboardType: 'user',
	dashboardFormData: DashboardFormDataFactory()
});

export const DashboardStateFactoryFromJS = function (data: IDashboardState) {
	return DashboardStateFactory({
		...data,
		widgets: WidgetStateFactoryFromJS(data.widgets),
		dashboardFormData: DashboardFormDataFactoryFromJS(data.dashboardFormData)
	});
};
